export const getNearestEmptyWidget = (widgetConfig) => {
    for (let index = 0; index < widgetConfig?.length; index++ ){
        if (widgetConfig[index].isEmpty) {
            return index;
        }
    }
    return -1;
};

export const canAddWidget = (widgetConfig) => {
    return widgetConfig?.filter((item) => {
        return item?.isEmpty
    })?.length > 0
}

export const getWidgetLocationName = (tagid, tags) => {
    return tags?.filter((item) => item.id === tagid)[0]?.name;
}

export const getWidgetLocationType = (tagid, tags) => {
    return tags?.filter((item) => item.id === tagid)[0]?.kind;
}


export const getLocationHierarchy = (siteTagList, locationTag) => {
    let hierarchyText = ""
    let matchingSubarea = siteTagList?.subareas?.filter((item) => item?.id === locationTag);
    let matchingArea = siteTagList?.areas?.filter((item) => item?.id === locationTag);
    let matchingFloor = siteTagList?.floors?.filter((item) => item?.id === locationTag);
    let matchingSite = []

    let matchingSelectedSite = siteTagList?.sites?.filter((item) => item?.id === locationTag);

    if (matchingSelectedSite?.length > 0) {
        hierarchyText += matchingSelectedSite[0]?.name;
    }
    if (matchingFloor?.length > 0) {
        hierarchyText+= matchingFloor[0]?.name;
        matchingSite = siteTagList?.sites?.filter((item) => item?.id === matchingFloor[0]?.tagids[0]);
        hierarchyText+= `/${matchingSite[0]?.name}`;
    } else if (matchingArea?.length > 0) {
        hierarchyText+= matchingArea[0]?.name;
        matchingFloor = siteTagList?.floors?.filter((item) => item?.id === matchingArea[0]?.tagids[0]);
        hierarchyText+= `/${matchingFloor[0]?.name}`;
        matchingSite = siteTagList?.sites?.filter((item) => item?.id === matchingFloor[0]?.tagids[0]);
        hierarchyText+= `/${matchingSite[0]?.name}`;
    } else if (matchingSubarea?.length > 0) {
        hierarchyText+= matchingSubarea[0]?.name;
        matchingArea = siteTagList?.areas?.filter((item) => item?.id === matchingSubarea[0]?.tagids[0]);
        hierarchyText+= `/${matchingArea[0]?.name}`;
        matchingFloor = siteTagList?.floors?.filter((item) => item?.id === matchingArea[0]?.tagids[0]);
        hierarchyText+= `/${matchingFloor[0]?.name}`;
        matchingSite = siteTagList?.sites?.filter((item) => item?.id === matchingFloor[0]?.tagids[0]);
        hierarchyText+= `/${matchingSite[0]?.name}`;
    }
    return hierarchyText?.split("/").reverse().join("/");
}